var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"inline-flex",class:[
    ("cursor-pointer text-" + _vm.color + " leading-" + _vm.leading + " text-" + _vm.size + " font-bold"),
    { 'cursor-not-allowed text-basic-600': _vm.disabled }
  ],on:{"click":function($event){!_vm.disabled && _vm.$emit('click', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }